import React from 'react'
import moment from 'moment'

// Page header: eyebrow + serif title + pulled/next-run meta + action buttons.
const ArAgingHeader = ({ data, loading, onRefresh, onExport, onPreview }) => {
  const runEyebrow = `AUTOMATED AR · 15TH RUN · ${moment().format('MMM YYYY').toUpperCase()}`
  const pulledLine = data?.fetchedAt
    ? `Pulled from Aspire ${moment(data.fetchedAt).format('M/D h:mm a')} · Next automated run ${moment().date(15).format('MMM D')}`
    : 'Pulling from Aspire…'

  return (
    <header className="ar-head">
      <div className="ar-head-left">
        <div className="ar-eyebrow">{runEyebrow}</div>
        <h1 className="ar-head-title">Accounts Receivable</h1>
        <div className="ar-head-meta">
          {pulledLine}
          {data?.fromCache && (
            <span className={`ar-cache-chip ${data.stale ? 'stale' : ''}`}>{data.stale ? 'stale cache' : 'cached'}</span>
          )}
        </div>
      </div>
      <div className="ar-head-actions">
        <button type="button" className="ar-btn ar-btn-outline" onClick={onExport} disabled={!data}>Export CSV</button>
        <button type="button" className="ar-btn ar-btn-outline" onClick={onRefresh} disabled={loading}>
          {loading ? 'Pulling…' : 'Refresh from Aspire'}
        </button>
        <button type="button" className="ar-btn ar-btn-primary" onClick={onPreview} disabled={!data}>Preview 15th Run</button>
      </div>
    </header>
  )
}

export default ArAgingHeader
